import _ from 'underscore';
import SessionStore from 'stores/shared/session';
import { t, loadLocales } from 'services/translation';

const FormControllerProxy = {
  // TODO: this function is temporarily misnamed. We have to see what current
  //   error messages are before we can translate them.
  // Currently only translating "can't be blank" messages
  _translateError(fieldName) {
    loadLocales(SessionStore.state.get('i18n'));
    return this.props.errors.get(fieldName).map((error) => {
      if (error.toLowerCase().includes("can't be blank")) {
        const cleanedFieldName =
          fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
        const translatedFieldName = t(cleanedFieldName.replace(/_/g, ' '));
        return `${translatedFieldName} ${t('CANT_BE_BLANK')}`;
      }
      if (error.toLowerCase().includes('not a valid email')) {
        return `${t('EMAIL_IS_INVALID')}`;
      }
      return `${error}`;
    });
  },

  _formProps(fieldName, otherProps) {
    const translatedErrors =
      this.props.errors.get(fieldName) !== undefined
        ? this._translateError(fieldName)
        : this.props.errors.get(fieldName);

    return _.extend(
      {
        name: fieldName,
        value: this.props.fields.get(fieldName),
        errors: translatedErrors,
        onChange: this.props.onChange,
      },
      otherProps
    );
  },
};

export default FormControllerProxy;
